import Chevron from '../../navigationMenu/components/chevron';
import { DealerManagementService } from 'src/services/dealer-management.service';
import Dropdown from '../../../../ui/dropdownMenu/dropdownMenu';
import { isSiteCanadian } from '../../../../../utils/helpers';
import { IUser } from '../../../../../utils/interfaces/user';
import Spinner from 'src/components/ui/spinner';
import { useLocalization } from 'src/utils/useLocalization';
import { USER_ACTIONS } from '../../../../../utils/enums/user-store-actions.enum';
import { ASSOCIATIONS_NAME, DEFAULTDEALER_NAME } from 'src/config';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../assets/dealers.scss';

interface IDealerMenuList {
    name: string;
    path?: string;
    handler?: any;
}

const DealersList: React.FC<{
    names: Array<{ dealerId: string; name: string }>;
}> = ({ names }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState<boolean>(false);
    const [rotateState, setRotateState] = useState<string>(
        'accordion__icon rotate',
    );
    const { currentDealers, accessUser, selectedDistrics } = useSelector(
        (state: IUser) => {
            return state;
        },
    );
    const { labelText } = useLocalization();
    const [loading, setLoading] = useState<boolean>(false);
    const [selected, setSelected] = useState<string>(
        currentDealers?.default ?? '',
    );
    const [selectedFullName, setSelectedFullName] = useState<string>(
        currentDealers?.default ?? '',
    );
    const [oldDistrict, setOldDistrict] = useState<string>('');
    const [list, setList] = useState<Array<IDealerMenuList>>([]);
    useEffect(() => {
        if (selected.length) {
            sessionStorage.setItem(DEFAULTDEALER_NAME, selected);
            dispatch({
                type: USER_ACTIONS.SET_DEFAULT_DEALER,
                payload: selected,
            });
        }
    }, [selected]);
    useEffect(() => {
        if (!accessUser) {
            const init = [
                {
                    name: 'Dealerships',
                },
            ];
            let aux: IDealerMenuList[] = [];
            let auxName = '';
            if (currentDealers?.dealers) {
                aux = currentDealers.dealers.length
                    ? currentDealers?.dealers
                          .map((ele: { dealerId: string }) => {
                              let dealerName = '';
                              if (names) {
                                  const name = names.find(
                                      (d) => d.dealerId === ele.dealerId,
                                  );
                                  dealerName = name ? ` - ${name.name}` : '';
                                  if (
                                      currentDealers &&
                                      currentDealers.default === ele.dealerId
                                  )
                                      auxName = dealerName;
                              }
                              return {
                                  name: `${ele.dealerId}${dealerName}`,
                                  id: ele.dealerId,
                                  path: '#',
                                  handler: () => {
                                      setSelected(`${ele.dealerId}`);
                                      setSelectedFullName(
                                          `${ele.dealerId}${dealerName}`,
                                      );
                                      dispatch({
                                          type: USER_ACTIONS.SET_DEFAULT_DEALER,
                                          payload: ele.dealerId,
                                      });
                                  },
                              } as IDealerMenuList;
                          })
                          .sort((a: any, b: any) => {
                              const numA = parseInt(a.id, 10);
                              const numB = parseInt(b.id, 10);

                              if (numA === numB) {
                                  return a.name.localeCompare(b.name);
                              }
                              return numA - numB;
                          })
                    : [];
            }
            setList(init.concat(aux));
            setSelected(
                currentDealers?.default ? `${currentDealers?.default}` : '',
            );
            setSelectedFullName(
                currentDealers?.default
                    ? `${currentDealers?.default}${auxName}`
                    : '',
            );
        } else if (selectedDistrics && oldDistrict !== selectedDistrics) {
            getDealerById(selectedDistrics);
        }
    }, [currentDealers, names, accessUser, selectedDistrics]);

    async function getDealerNamesData(dealerIds: [string]) {
        const service = new DealerManagementService();
        try {
            const res = await service.getDealerNames(dealerIds);
            if (res?.data) {
                const namesList = res.data.dealers.map((dealer: any) => {
                    return { dealerId: dealer.dealerId, name: dealer.name };
                });
                return namesList;
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function getDealerById(selectedDistrics: any) {
        try {
            setLoading(true);
            const service = new DealerManagementService();
            const res = await service.getDealerNamesByDistrict(
                selectedDistrics,
            );
            if (res.data.dealerIds.length) {
                let auxName = '';
                const dealers: Array<{ dealerId: string }> = [];
                res.data.dealerIds.map(
                    (ele: { manufacturerUniqueId: string }) => {
                        dealers.push({ dealerId: ele.manufacturerUniqueId });
                    },
                );
                const newNames = await getDealerNamesData(
                    res.data.dealerIds.map(
                        (ele: { manufacturerUniqueId: string }) =>
                            ele.manufacturerUniqueId,
                    ),
                );
                const aux = res.data.dealerIds
                    .map((ele: { manufacturerUniqueId: string }) => {
                        let dealerName = '';
                        if (newNames) {
                            const name = newNames.find(
                                (d: { dealerId: string }) =>
                                    d.dealerId === ele.manufacturerUniqueId,
                            );
                            dealerName = name ? ` - ${name.name}` : '';
                            if (
                                currentDealers &&
                                currentDealers.default ===
                                    ele.manufacturerUniqueId
                            )
                                auxName = dealerName;
                        }
                        return {
                            name: `${ele.manufacturerUniqueId}${dealerName}`,
                            id: ele.manufacturerUniqueId,
                            path: '#',
                            handler: () => {
                                setSelected(`${ele.manufacturerUniqueId}`);
                                setSelectedFullName(
                                    `${ele.manufacturerUniqueId}${dealerName}`,
                                );
                                dispatch({
                                    type: USER_ACTIONS.SET_DEFAULT_DEALER,
                                    payload: ele.manufacturerUniqueId,
                                });
                            },
                        } as IDealerMenuList;
                    })
                    .sort((a: any, b: any) => {
                        const numA = parseInt(a.id, 10);
                        const numB = parseInt(b.id, 10);

                        if (numA === numB) {
                            return a.name.localeCompare(b.name);
                        }
                        return numA - numB;
                    });
                setList(aux);
                setOldDistrict(selectedDistrics);
                sessionStorage.setItem(
                    ASSOCIATIONS_NAME,
                    JSON.stringify(dealers),
                );
                dispatch({
                    type: USER_ACTIONS.SET_DEALERS,
                    payload: {
                        default: currentDealers?.default,
                        dealers,
                    },
                });
                setSelected(
                    currentDealers?.default ? currentDealers.default : '',
                );
                setSelectedFullName(
                    currentDealers?.default
                        ? `${currentDealers?.default}${auxName}`
                        : '',
                );
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
        }
    }

    return (
        <div
            className={'dealer-list'}
            onClick={() => {
                setOpen(!open);
                setRotateState(
                    open
                        ? 'accordion__icon rotate'
                        : 'accordion__icon rotate-270',
                );
            }}
            aria-hidden={true}
        >
            <div className='dealer-list__container-presenter'>
                <i
                    className={
                        'c-icon-list__icon c-icon c-icon--[semantic-dealer]'
                    }
                    aria-hidden='true'
                    role='img'
                />
                {selectedFullName !== 'null' && selectedFullName
                    ? selectedFullName
                    : `${labelText.LABEL_TEXT_DASH_SELECT} ${labelText.LABEL_TEXT_DASH_DEALERSHIP}`}
                <span className={'u-ml-xsmall'}>
                    {!loading ? (
                        <Chevron
                            className={`${rotateState}`}
                            width={10}
                            fill={'#777'}
                        />
                    ) : (
                        <span
                            style={{ width: 10, height: 10, display: 'block' }}
                        >
                            <Spinner
                                style={{
                                    '--spinner-size': '10px',
                                }}
                            />
                        </span>
                    )}
                </span>
            </div>
            {!loading ? (
                <Dropdown
                    dropdown={open}
                    submenus={list}
                    handlerChange={(value: boolean) => {
                        setOpen(value);
                        setRotateState(
                            !value
                                ? 'accordion__icon rotate'
                                : 'accordion__icon rotate-270',
                        );
                    }}
                    handlerItemChange={setSelectedFullName}
                    showSelected={selected !== ''}
                    defaultSelected={selected || ' '}
                    showSelectedIcon={selected !== ''}
                    right={!isSiteCanadian() ? '75' : '145'}
                    isDealership={true}
                />
            ) : null}
        </div>
    );
};

export default DealersList;
